import React, { Component } from 'react';
import { connect } from "react-redux";
import ActivationMetrics from './ActivationMetrics';
import TopActivitiesTable from './TopActivitiesTable';
import PostOpsoResult from './PostOpsoResult';
import TopBottomActivities from './TopBottomActivities';
import TTS from './TTS';
import DTTS from './DTTS';
import GTMTSplit from './GTMTSplit';
import ChannelUtilization from './ChannelUtilization';
import PratDashboardMiddleware from '../../store/prat_middleware/pratDashboard/pratDashboardMiddleware';
import ProductMiddleware from "../../store/prat_middleware/gt/productMiddleware";
import ChannelMiddleware from "../../store/prat_middleware/gt/channelMiddleware";
import { Loader } from "../../components/loader";
import './PratDashboard.styles.scss';

class PratDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialLoading:true
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.props.getMapCategories();
      this.props.get_productBrands();
      this.props.get_masterChannel();
      this.props.get_productDivisions();
    }, 1000)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps?.mapCategory?.length) {
        this.setState({
          initialLoading:false
        })
    }
}

  render() {
    return (

      <div className="page-container">

        {this.props?.mapCategory?.length < 1 || this.state.initialLoading ?
        <Loader flag={true}/>
        :
          <>

        <div className="heading-and-download-container">

          <span className='component-heading'>PRAT Dashboard</span>

        </div>

        <TopActivitiesTable categories={this.props?.mapCategory} brands={this.props?.product_brands}/>

        <div style={{display:'flex'}}>
          <TTS categories={this.props?.mapCategory}/>

          <DTTS categories={this.props?.mapCategory}/>
        </div>

        <ActivationMetrics categories={this.props?.mapCategory} />

        <PostOpsoResult categories={this.props?.mapCategory} />

        <TopBottomActivities categories={this.props?.mapCategory} />

        <div style={{display:'flex'}}>
          <GTMTSplit categories={this.props?.mapCategory} masterChannel={this.props?.master_channel}/>

          <ChannelUtilization categories={this.props?.mapCategory} product_divisions={this.props?.product_devisions}/>
        </div>

        </>}

      </div>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    mapCategory: state.PratDashboardReducer.mapCategory,
    product_brands: state.ProductReducer.productBrands,
    isMapCategoryLoading: state.PratDashboardReducer.isMapCategoryLoading,
    master_channel: state.GtChannelReducer.masterChannel,
    product_devisions: state.ProductReducer.productDevisions
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getMapCategories: () => {
      return dispatch(PratDashboardMiddleware.getMapCategories());
    },
    get_productBrands: () => {
      return dispatch(ProductMiddleware.get_brands());
    },
    get_masterChannel: () => {
        return dispatch(ChannelMiddleware.get_masterChannel());
    },
    get_productDivisions: () => {
      return dispatch(ProductMiddleware.get_devisions());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(PratDashboard);
